import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Logger } from 'kinedu-react-components';
import { loggerSaver } from '../../appEvents/index';
import { ENV, APP_VERSION, IS_PROD, IS_STAGING } from '../../config';
import i18n from '../../i18n';
import { handleLogOut } from '../../lib/general';
import ParamList from './ParamList';

const StyledLoggerContainer = styled.div``;

const apiEnvStatus = (env: "STAGE" | "PRODUCTION") => {
  if (IS_PROD) {
      return {
        title: 'API IS ON PRODUCTION',
        color: '#EF4040',
      };
  } else {
    if (IS_STAGING) {
      return {
        title: 'API IS ON STAGING',
        color: '#EF4040',
      };
    }
  }
  return {
    title: env,
    color: '#e97000',
  };
};

const setLanguage = (lang: string) => i18n.changeLanguage(lang);

const APP_LOGS = (events: any, user: any, isPremium: boolean, subscription: any) => [
  {
    title: apiEnvStatus(ENV).title,
    color: apiEnvStatus(ENV).color,
    hide: IS_PROD,
  },
  {
    title: '',
    color: '#E0E0E0',
    open: false,
    childs: [
      {
        title: `v${APP_VERSION}`,
        color: '#eda020',
      },
      {
        title: isPremium ? `PREMIUM: ${subscription.subscriptionType || ''}` : 'FREEMIUM',
        color: isPremium ? '#be9f00' : '#0fb9a3',
      },
      {
        title: 'Events',
        color: '#088f00',
        childs: events,
      },
      {
        title: 'Set langs',
        color: '#008ab8',
        childs: [
          {
            title: 'EN',
            color: '#0c76b5',
            action: () => setLanguage('en'),
          },
          {
            title: 'ES',
            color: '#dc7a00',
            action: () => setLanguage('es'),
          },
          {
            title: 'PT',
            color: '#00a023',
            action: () => setLanguage('pt'),
          },
        ],
      },
      {
        title: 'Actions',
        color: '#776bf7',
        childs: [
          {
            title: 'Logout',
            action: () => handleLogOut(),
            color: '#165E96',
          },
        ],
      },
      {
        title: `Type: ${user.type?.toUpperCase()}`,
        color: '#c25df5',
        hide: !user.type,
      },
      {
        title: 'Info',
        color: '#5d81f5',
        childs: [
          {
            title: 'User',
            content: () => (
              <>
                <span>
                  <strong>Email: </strong>
                  <span>{user.email}</span>
                </span>
                <span>
                  <strong>Name: </strong>
                  <span>
                    {user.name}
                    {' '}
                    {user.lastname}
                  </span>
                </span>
                <span>
                  <strong>Locale: </strong>
                  <span>{user.locale}</span>
                </span>
                <span>
                  <strong>Role: </strong>
                  <span>{user.type}</span>
                </span>
                <span>
                  <strong>Title: </strong>
                  <span>{user.title}</span>
                </span>
              </>
            ),
          },
        ],
      },
    ],
  },
];

const LoggerContainer = ({ user = {}, isPremium, subscription = {} }: any) => {
  const [eventList, setEventList] = useState([]);
  const events = eventList && eventList.map((event: any) => ({
    title: event.tag,
    content: () => (<ParamList params={event?.params} />),
    labels: event?.providers,
  }));

  useEffect(() => {
    const sub = loggerSaver.getEvents().subscribe((value: any) => {
      setEventList(value);
    });
    return () => sub.unsubscribe();
    /* eslint-disable-next-line */
  }, []);

  return (
    <StyledLoggerContainer>
      <Logger
        data={APP_LOGS(events, user, isPremium, subscription)}
        show={!IS_PROD}
      />
    </StyledLoggerContainer>
  );
};

export default LoggerContainer;
